(function($) {
	$( document ).ready(
		function() {
			$( '.taxonomyList' ).on(
				'change',
				function(e) {
					e.preventDefault()

					if ($( this ).hasClass( 'taxonomyList--blog' )) {
						var query = [],
						base_url = window.location.pathname,
						load_url = base_url,
						category = $( '.taxonomyList-terms .btn--blog.active' ).attr('data-value');

						if ( category !== "" ) {
							query.push( "category=" + category );
						}

						query = query.join( "&", query );

						if ( query.length ) {
							load_url = load_url + "?" + query;
						}

						$( '#ajax-posts' ).load(
							base_url + '?category=' + category + ' #ajax-posts>*'
						);
						$( '#pagination' ).load(
							base_url + '?category=' + category + ' #pagination>*'
						);

						history.pushState( {'category': category}, "Results", load_url );
					}
				}
			);

			$( '.btn--blog' ).click(
				function(e) {
					e.preventDefault()
					$( '.btn--blog' ).removeClass( 'active' )
					$( this ).addClass( 'active' )

					$( '.taxonomyList' ).trigger( 'change' )
				}
			);

			$( '#pagination' ).on(
				'click',
				'a',
				function(e){
					e.preventDefault();
					$( this ).remove();

					var load_url = $( this ).attr( 'href' )

          if ($('.taxonomyList--blog').length) {
            var query = [],
            category = $( '.taxonomyList-terms .btn--blog.active' ).attr('data-value');

            if( category !== "" ){
              query.push( "category=" + category );
            }

            query = query.join("&", query);

            if( query.length ){
              load_url = load_url + "&" + query;
            }
          }

					$( '#ajax-loader' ).load(
						load_url + ' #ajax-posts>*',
						function(){
							$( '#ajax-posts' ).append( $( '#ajax-loader' ).html() );
						}
					);
					$( '#pagination' ).load(
						load_url + ' #pagination>*',
						function() {
							console.log( 'done' )
						}
					);
				}
			);

			function getUrlParameter(sParam) {
				var sPageURL = decodeURIComponent( window.location.search.substring( 1 ) ),
				  sURLVariables = sPageURL.split( '&' ),
				  sParameterName,
				  i;

				for (i = 0; i < sURLVariables.length; i++) {
					sParameterName = sURLVariables[i].split( '=' );

					if (sParameterName[0] === sParam) {
						return sParameterName[1] === undefined ? true : sParameterName[1];
					}
				}
			}

			// function pageLoad() {
			// 	if (getUrlParameter( 'category' ) !== undefined) {
   //        $( '.taxonomyList-terms .btn--blog[data-value="' + getUrlParameter( 'category' ) + '""]' ).addClass('')
			// 	}
			// }
			// pageLoad()

		}
	)
})( jQuery );
